<div
  class="table-responsive"
  [ngClass]="tableResponsiveClass"
  *ngIf="data != null && data.data != null; else loading_box"
>
  <table class="table datatables-ajax">
    <thead class="table-header-dark-light">
      <tr class="table-light" cdkDropList (cdkDropListDropped)="drop($event)">
        <th scope="col" [ngClass]="tdClass" class="side-column px-1">#</th>
        <th
          scope="col"
          [ngClass]="tdClass"
          class="sortable position-relative"
          *ngFor="let headerField of tableHeader; let i = index"
        >
          <div class="header-box">
            <button
              type="button"
              class="btn btn-label-secondary btn-icon move-button"
              cdkDrag
            >
              <i class="bx bx-move"></i>
            </button>
            <span>
              {{ headerField.label | translate }}
            </span>
            <button
              type="button"
              class="btn btn-label-secondary btn-icon"
              *ngIf="data.sorable"
              (click)="callParent(headerField.fieldName, 'Sort')"
            >
              <i
                [ngClass]="{
                  'bx bx-sort-alt-2':
                    data.sortingColumnName != headerField.fieldName,
                  'fas fa-sort-alpha-down':
                    data.sortingColumnName == headerField.fieldName &&
                    data.direction == 'asd',
                  'fas fa-sort-alpha-up':
                    data.sortingColumnName == headerField.fieldName &&
                    data.direction == 'desc'
                }"
              >
              </i>
            </button>
            <span
              class="resize-handle"
              (mousedown)="onMouseDown($event, i + 1)"
            ></span>
          </div>
        </th>
        <th
          scope="col"
          [ngClass]="tdClass"
          class="side-column px-1"
          *ngIf="data.rowButtoms.length > 0"
        >
          &nbsp;
        </th>
      </tr>
    </thead>
    <tbody class="table-body-dark-light">
      <tr
        *ngFor="let row of data.data; let i = index"
        [ngClass]="{
          'keyboard-focus': focusRow === i,
          'warning-row': row.saleState == 'NoPayment' || row.rowColor == 'Warning',
          'success-row': row.saleState == 'Paid' || row.rowColor == 'Success',
          'danger-row': row.saleState == 'Return' || row.rowColor == 'Danger',
        }"
        (click)="callParent(row, 'SelectItem')"
        (contextmenu)="openNote($event, row)"
      >
        <td scop="row" [ngClass]="tdClass" class="side-column px-1">
          {{ i + data.startIndex }}
        </td>

        <ng-container *ngIf="inlineEdit; else elseNoInline">
          <ng-container *ngIf="row['inlineEditState'] == true; else elseNoEdit">
            <td
              *ngFor="let cell of tableHeader; let headerIndex = index"
              [ngClass]="tdClass"
            >
              <i
                [ngClass]="
                  row[cell.camelCaseName!]
                    ? 'bx bx-check-circle'
                    : 'bx bx-x-circle'
                "
                *ngIf="cell.fieldType == 'Boolean'"
              ></i>
              <input
                type="text"
                *ngIf="cell.fieldType == 'Int64'"
                class="form-control input-number"
                [(ngModel)]="row[cell.camelCaseName!]"
                (keyup)="checkNumber(i, row[cell.camelCaseName!])"
              />
              <input
                type="text"
                *ngIf="cell.fieldType == 'String'"
                class="form-control"
                [(ngModel)]="row[cell.camelCaseName!]"
              />
            </td>
          </ng-container>
          <ng-template #elseNoEdit>
            <td *ngFor="let cell of tableHeader">
              <i
                [ngClass]="
                  row[cell.camelCaseName!]
                    ? 'bx bx-check-circle'
                    : 'bx bx-x-circle'
                "
                *ngIf="cell.fieldType == 'Boolean'"
              ></i>
              {{ row[cell.camelCaseName!] | dataType : cell.camelCaseName }}
            </td>
          </ng-template>
        </ng-container>
        <ng-template #elseNoInline>
          <td *ngFor="let cell of tableHeader" [ngClass]="tdClass">
            <i
              [ngClass]="
                row[cell.camelCaseName!]
                  ? 'bx bx-check-circle'
                  : 'bx bx-x-circle'
              "
              *ngIf="cell.fieldType == 'Boolean'"
            ></i>
            {{
              row[cell.camelCaseName!]
                | dataType : cell.camelCaseName
                | translate
            }}
          </td>
        </ng-template>
        <td
          class="side-column px-1"
          *ngIf="data.rowButtoms.length > 0"
          [ngClass]="tdClass"
        >
          <div class="btn-group" style="position: unset">
            <ng-container *ngFor="let item of data.rowButtoms">
              <ng-container *ngIf="this.inlineEdit == true; else noEditInline">
                <ng-container
                  *ngIf="item.name == 'Edit' && row['inlineEditState'] == false"
                >
                  <button
                    type="button"
                    class="btn btn-icon"
                    [ngClass]="item.className"
                    ngbTooltip="{{ item.name | translate }}"
                    (click)="callParent(row, item.name)"
                  >
                    <i [ngClass]="item.icon"> </i>
                  </button>
                </ng-container>

                <ng-container
                  *ngIf="item.name == 'Save' && row['inlineEditState'] == true"
                >
                  <button
                    type="button"
                    class="btn btn-icon"
                    [ngClass]="item.className"
                    ngbTooltip="{{ item.name | translate }}"
                    (click)="callParent(row, item.name)"
                  >
                    <i [ngClass]="item.icon"> </i>
                  </button>
                </ng-container>

                <ng-container
                  *ngIf="item.name != 'Save' && item.name != 'Edit'"
                >
                  <button
                    type="button"
                    class="btn btn-icon"
                    [ngClass]="item.className"
                    ngbTooltip="{{ item.name | translate }}"
                    (click)="callParent(row, item.name)"
                  >
                    <i [ngClass]="item.icon"> </i>
                  </button>
                </ng-container>
              </ng-container>

              <ng-template #noEditInline>
                <button
                  *ngIf="checkConditionButton(row, item)"
                  type="button"
                  class="btn btn-icon"
                  [ngClass]="item.className"
                  ngbTooltip="{{ item.name | translate }}"
                  (click)="callParent(row, item.name)"
                >
                  <i [ngClass]="item.icon"> </i>
                </button>
              </ng-template>
            </ng-container>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div
    *ngIf="showPopup"
    [ngStyle]="{ top: popupTop + 'px', left: popupLeft + 'px' }"
    class="popup"
  >
    <div class="button-box p-2">
      <ng-container
        *ngFor="let item of data.rowButtoms; let buttonIndex = index"
      >
        <ng-container *ngIf="this.inlineEdit == true; else noEditInline">
          <ng-container
            *ngIf="
              item.name == 'Edit' && rightClickItem['inlineEditState'] == false
            "
          >
            <button
              type="button"
              class="btn"
              [ngClass]="item.className"
              [class.mb-2]="buttonIndex + 1 != data.rowButtoms.length"
              (click)="callParent(rightClickItem, item.name)"
            >
              <i [ngClass]="item.icon"> </i>
              {{ item.name | translate }}
            </button>
          </ng-container>

          <ng-container
            *ngIf="
              item.name == 'Save' && rightClickItem['inlineEditState'] == true
            "
          >
            <button
              type="button"
              class="btn"
              [ngClass]="item.className"
              [class.mb-2]="buttonIndex + 1 != data.rowButtoms.length"
              (click)="callParent(rightClickItem, item.name)"
            >
              <i [ngClass]="item.icon"> </i>
              {{ item.name | translate }}
            </button>
          </ng-container>

          <ng-container *ngIf="item.name != 'Save' && item.name != 'Edit'">
            <button
              type="button"
              class="btn"
              [ngClass]="item.className"
              [class.mb-2]="buttonIndex + 1 != data.rowButtoms.length"
              (click)="callParent(rightClickItem, item.name)"
            >
              <i [ngClass]="item.icon"> </i>
              {{ item.name | translate }}
            </button>
          </ng-container>
        </ng-container>

        <ng-template #noEditInline>
          <button
            *ngIf="checkConditionButton(rightClickItem, item)"
            type="button"
            class="btn"
            [ngClass]="item.className"
            [class.mb-2]="buttonIndex + 1 != data.rowButtoms.length"
            (click)="callParent(rightClickItem, item.name)"
          >
            <i [ngClass]="item.icon"> </i>
            {{ item.name | translate }}
          </button>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loading_box>
  <div class="table-responsive">
    <table class="table datatables-ajax">
      <thead class="table-header-dark-light">
        <tr class="table-light">
          <th scope="col" class="sortable">&#160;</th>
        </tr>
      </thead>
      <tbody class="table-body-dark-light">
        <td colspan="500" [ngClass]="tdClass">
          <div class="app-loading loading-table"></div>
        </td>
      </tbody>
    </table>
  </div>
</ng-template>
